import { render } from "./OrderDetailsComponent.vue?vue&type=template&id=67d97632"
import script from "./OrderDetailsComponent.vue?vue&type=script&lang=js"
export * from "./OrderDetailsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/account/orderDetails/OrderDetailsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "67d97632"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('67d97632', __exports__)) {
    api.reload('67d97632', __exports__)
  }
  
  module.hot.accept("./OrderDetailsComponent.vue?vue&type=template&id=67d97632", () => {
    api.rerender('67d97632', render)
  })

}


export default __exports__